export default __webpack_public_path__ + "static/media/darksubmissionFile.f386b017.svg";